import { Button } from "@material-ui/core";
import { makeThemedStyles } from "@qpr/client-api-base/viewcomponents/utils";
import flattenHierarchy from "backend/flattenHierarchy";
import { ICardElementWithChildren } from "backend/model/model";
import React from "react";
import SummaryPopoover from "../popups/SummaryPopover";
import clsx from "clsx";
import ExpandMore from "@material-ui/icons/ExpandMore";

const useDepartmentCardStyles = makeThemedStyles("DepartmentCard", (theme) => ({
  root: {
    width: "250px",
    borderRadius: "2px",
    color: "white",
  },
  card: {
    width: "100%",
    height: "130px",
    borderRadius: "1.6em",
    overflow: "hidden",
    position: "relative",
    background:
      "linear-gradient(270deg, rgba(16, 41, 117, 0.37) -0.1%, rgba(16, 41, 117, 0.83) 83.43%)",
  },
  content: {
    width: "100%",
    padding: "1.9em 2em 1.4em 2em",
    height: "calc(100% - 3.8em)",
    cursor: "pointer",
    background:
      "linear-gradient(270deg, rgba(16, 41, 117, 0.17) -0.1%, rgba(16, 41, 117, 0.83) 83.43%), var(--backgroundImage)",
  },
  type: {
    color: "rgba(245, 246, 246, 1)",
    fontSize: "1.2em",
    lineHeight: "1.25",
    fontWeight: 500,
    marginBottom: "0.66em",
  },
  name: {
    color: "rgba(255, 255, 255, 1)",
    fontSize: "1.4em",
    lineHeight: "1.428",
    fontWeight: 600,
    letterSpacing: "0.05625px",
    maxWidth: "15.07em",
  },
  title: {
    color: "white",
  },
  titleTypeName: {
    color: "white",
  },
  cardActions: {
    background: "rgba(255, 255, 255, 1)",
    width: "100%",
    height: "3.8em",
  },
  cardActionsButton: {
    background: "rgba(255, 255, 255, 1)",
    width: "100%",
    height: "100%",
    color: "rgba(16, 41, 117, 1)",
    fontSize: "1.2em",
    borderRadius: 0,
    display: "flex",
    justifyContent: "space-between",
    padding: "0 1.5833em",
    "&.RTL": {
      "& svg": {
        transform: "rotate(90deg)",
      },
    },
    "& svg": {
      fill: "rgba(63, 69, 79, 1)",
      transform: "rotate(-90deg)",
    },
  },
  range: {
    position: "absolute",
    top: "1.2em",
    right: "1.2em",
    height: "1.8em",
    width: "1.8em",
    borderRadius: "50%",
    background: "rgba(221, 81, 70, 1)",
    border: "2px solid rgb(255, 255, 255)",
  },
}));

export const DepartmentCardTitle = (props: React.PropsWithChildren<{}>) => {
  const styles = useDepartmentCardStyles();
  return <div className={styles.title}>{props.children}</div>;
};

export const DepartmentCardTypeName = (props: React.PropsWithChildren<{}>) => {
  const styles = useDepartmentCardStyles();
  return <div className={styles.titleTypeName}>{props.children}</div>;
};

export const DepartmentCard = (
  props: React.PropsWithChildren<{
    element: ICardElementWithChildren;
    rtl?: boolean;
    onSelect?: () => void;
    typenames: {
      name: string;
      title: string;
    }[];
  }>
) => {
  const ref = React.useRef<HTMLButtonElement>(null);
  const [showPopover, setShowPopover] = React.useState(false);
  const styles = useDepartmentCardStyles();
  const { element: el } = props;
  const childrenFlat = React.useMemo(
    () => flattenHierarchy(props.element.children),
    [props.element]
  );

  const typeCounts = React.useMemo(() => {
    return props.typenames.map((tn) => {
      return {
        typename: tn.name,
        title: tn.title,
        count: childrenFlat.filter((el) => el.typename === tn.name).length,
      };
    });
  }, [childrenFlat]);
  return (
    <div
      className={styles.root}
      role="button"
      style={{ cursor: props.onSelect ? "pointer" : undefined }}
      tabIndex={0}
      onKeyDown={() => {}}
      onClick={() => {
        if (props.onSelect && !showPopover) {
          props.onSelect();
        }
      }}
    >
      <div className={styles.card}>
        <div
          className={styles.range}
          title={el.rangename || "No value"}
          style={{ background: `#${el.rangecolor || "000000"}aa` }}
        ></div>
        <div className={styles.content}>
          <div className={styles.type}>{el.typename}</div>
          <div className={styles.name}>{el.name}</div>
        </div>
      </div>
    </div>
  );
};
